const Avatar = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5_7862)">
        <circle cx="12" cy="12" r="12" fill="#93A8B3" />
        <path
          d="M17 13C17.5523 13 18.0085 13.4508 17.9169 13.9954C17.842 14.4406 17.7169 14.877 17.5433 15.2961C17.2417 16.0241 16.7998 16.6855 16.2426 17.2426C15.6855 17.7998 15.0241 18.2417 14.2961 18.5433C13.5681 18.8448 12.7879 19 12 19C11.2121 19 10.4319 18.8448 9.7039 18.5433C8.97595 18.2417 8.31451 17.7998 7.75736 17.2426C7.20021 16.6855 6.75825 16.0241 6.45672 15.2961C6.28313 14.877 6.15804 14.4406 6.08314 13.9954C5.99152 13.4508 6.44772 13 7 13L17 13Z"
          fill="white"
        />
        <circle cx="12" cy="8.5" r="3.5" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_5_7862">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Avatar;
